import { editWebConstants } from "../../../../constants/Web/editWebContent.constans";

const initialState = {
    fetching :false,
    editWebData: [],
    error    :{},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case editWebConstants.GET_EDIT_CONTENT_WEB_PENDING:
            return {
                ...state,
                fetching:true,
            };
        case editWebConstants.GET_EDIT_CONTENT_WEB_FULFILLED:
            return {
                ...state,
                fetching : false,
                error    : false,
                editWebData: action.payload,
            };
        case editWebConstants.GET_EDIT_CONTENT_WEB_REJECTED:
            return {
                ...state,
                fetching : false,
                error: action.payload
            }
        default:
            return state
    }
}
